import React from "react";
import { useState } from "react";
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import { FaWpforms } from "react-icons/fa";
import {
  Backdrop,
  Button,
  Card,
  CardMedia,
  Fade,
  IconButton,
  Link,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { admissionModal } from "../static";
import { FaBangladeshiTakaSign, FaRegPaperPlane } from "react-icons/fa6";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  bgcolor: "background.paper",
};

export const AdmissionModal = () => {
  const [open, setOpen] = useState(true);
  const handleClose = () => setOpen(false);
  return (
    <>
      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
        sx={{ border: "none" }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              size="small"
              className="modalCloseButton"
              sx={{
                position: "absolute",
                right: 2,
                top: 2,
                color: "#43426E",
              }}
            >
              <CloseIcon fontSize="large" />
            </IconButton>
            <Card variant="outlined">
              <Link href="/tuitionFees" underline="none">
                <CardMedia
                  component="img"
                  image={admissionModal}
                  alt="Admission Is Going on at Eastern University"
                />
              </Link>
              <div className="d-flex p-4 justify-content-center gap-2">
                <Button
                  className="mx-1"
                  variant="contained"
                  startIcon={<FaWpforms />}
                >
                  <Link
                    href="/OnlineAdmission"
                    underline="none"
                    style={{ color: "#fff" }}
                  >
                    Online Admission
                  </Link>
                </Button>
                <Button
                  className="mx-1"
                  variant="contained"
                  startIcon={<FaBangladeshiTakaSign />}
                >
                  <Link
                    href="/tuitionFees"
                    underline="none"
                    style={{ color: "#fff" }}
                  >
                    Tuition Fees
                  </Link>
                </Button>
                <Button
                  className="mx-1"
                  variant="contained"
                  startIcon={<FaRegPaperPlane />}
                >
                  <a
                    href="mailto:info@easternuni.edu.bd"
                    style={{ color: "#fff" }}
                  >
                    Message Us
                  </a>
                </Button>
              </div>
            </Card>
          </Box>
        </Fade>
      </Modal>
    </>
  );
};
